import {Flex as MantineFlex} from '@mantine/core';

/**
 * Flexbox container — design-layer pass-through over Mantine `Flex`.
 * @registry Pass-through Mantine Flex; import this instead of @mantine/core outside src/design.
 */
export const Flex = MantineFlex;
